
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/leaderboards/bookmarks",
      function () {
        return require("private-next-pages/leaderboards/bookmarks.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/leaderboards/bookmarks"])
      });
    }
  